// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_3XvmF","modalControls":"_3pa-j","deleteBtnWrapper":"_2V1__"};